module.exports = __webpack_public_path__ + "static/media/bg2.f3d84793.png";